import React from 'react';
import { Button, Summary } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Container } from '../../../../symphony';

import { ActionType, RequestType } from '../../global-interface';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { NotFoundPages, lePlaygroundContext } from '../../global-constants';

import s from './MaterialNotFound.scss';
import { ActionButtonTypes } from '../../../../shared/public/SlActionButton/SlActionButton';

export function MaterialNotFound(): JSX.Element {
	useStyles(s);
	const onButtonClick = () => {
		const { actions$ } = Container.take(lePlaygroundContext.value, SlActions);
		actions$.next({
			type: ActionType.OnMaterialNotFoundClick,
			requestType: RequestType.Parallel,
		});
	};
	return (
		<div sl-test-data="cmpLEMaterialNotFound">
			<Summary
				actions={[
					<Button
						sl-test-data="btnMaterialNotFound"
						type={ActionButtonTypes.primary}
						onClick={onButtonClick}
						key={0}
					>
						{NotFoundPages.MATERIAL_NOT_FOUND.button.title}
					</Button>,
				]}
				className="le-not-found"
				description={NotFoundPages.MATERIAL_NOT_FOUND.description}
				headline={NotFoundPages.MATERIAL_NOT_FOUND.title}
			/>
		</div>
	);
}
